import React from "react"
import { Currencies } from "@orbital/games-frontend-library"
import { SubTitle } from "../../GameBoardStyled"
import { STAKE_CREDENTIALS_PROPS } from "./inteface"

export default function StakeCredential({
  stake,
  currency,
  precision,
}: STAKE_CREDENTIALS_PROPS): JSX.Element {
  return (
    <div>
      <SubTitle className={+stake > 0 ? "active" : ""}>
        <p className='currency'>{Currencies[currency]}</p>
        <span> {Number(stake) > 0 ? (+stake).toFixed(precision) : 0}</span>
      </SubTitle>
    </div>
  )
}
